import React, { PropsWithChildren } from 'react';
import { Pane, Flex, Text } from '@fullstory/components';

export const InspectModeCard: React.FC<
  PropsWithChildren<{ title: string; control?: React.ReactNode }>
> = ({ title, children, control, ...restOfProps }) => (
  <Pane
    data-component="InspectModeCard"
    border="standard"
    borderRadius={8}
    padding={8}
    backgroundColor="secondary"
    {...restOfProps}
  >
    <Pane
      border="standard"
      borderRadiusTopLeft={8}
      borderRadiusTopRight={8}
      backgroundColor="default"
      paddingLeft={16}
      paddingRight={16}
      paddingBottom={12}
      paddingTop={12}
    >
      <Flex justifyContent="space-between">
        <Text appearance="heading3" color="emphasized">
          {title}
        </Text>
        {control}
      </Flex>
    </Pane>
    <Pane
      border="standard"
      backgroundColor="default"
      padding={16}
      borderRadiusBottomLeft={8}
      borderRadiusBottomRight={8}
    >
      {children}
    </Pane>
  </Pane>
);
